import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Common/Icon';

// If you pass in an icon it will override the text

const Button = ({ type, bootstrapClass, name, text, iconName, onClick, isDisabled }) => {
    const child = (iconName) ? <Icon name={iconName} /> : text;
    const bsClass = (bootstrapClass) ? " btn-" + bootstrapClass : "";
    const cls = "btn" + bsClass;
    return (
        <Fragment>
            { isDisabled ?
                <button name={name} type={type} title={text} className={cls} onClick={onClick} disabled>{child}</button>        
            :
                <button name={name} type={type} title={text} className={cls} onClick={onClick}>{child}</button>
            }            
        </Fragment>
    );
};

Button.propTypes = {
    type: PropTypes.string.isRequired,
    bootstrapClass: PropTypes.string,
    name: PropTypes.string,
    text: PropTypes.string,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    isDisabled: PropTypes.bool,
};

export default Button;
